/**
 * Política canônica de NOVAS senhas — espelha
 * ``backend/security/passwords.py::validate_new_password``.
 *
 * Regras (backend é a autoridade — o frontend apenas antecipa):
 *  - mínimo de 10 caracteres;
 *  - não pode ser apenas espaços em branco;
 *  - não exige composição artificial (maiúscula/minúscula/número/símbolo).
 *
 * Este módulo centraliza textos + validação visual para evitar
 * duplicação entre AcceptInvite.jsx e Settings.jsx.
 */
export const PASSWORD_MIN_LENGTH = 10;

/**
 * Retorna a lista de critérios com o rótulo em PT-BR e um flag ``ok``
 * indicando se a senha atual satisfaz a regra. Não guarda a senha.
 */
export function passwordPolicyChecks(pw) {
  const s = typeof pw === "string" ? pw : "";
  const trimmed = s.trim();
  return [
    {
      key: "min",
      label: `Pelo menos ${PASSWORD_MIN_LENGTH} caracteres`,
      ok: s.length >= PASSWORD_MIN_LENGTH,
    },
    {
      key: "not-blank",
      label: "Não pode ser apenas espaços em branco",
      ok: s.length > 0 && trimmed.length > 0,
    },
  ];
}

/**
 * Retorna ``true`` se a senha satisfaz TODOS os critérios da política.
 */
export function isPasswordValid(pw) {
  return passwordPolicyChecks(pw).every((c) => c.ok);
}

/**
 * Retorna ``true`` quando as duas senhas coincidem e são não-vazias.
 */
export function passwordsMatch(a, b) {
  return typeof a === "string" && a.length > 0 && a === b;
}
